// const colorArr = [
//   '#5B8FF9',
//   '#5AD8A6',
//   '#5D7092',
//   '#F6BD16',
//   '#E86452',
//   '#6DC8EC',
//   '#945FB9',
//   '#FF9845',
//   '#1E9493',
//   '#FF99C3',
//   '#40E4A2',
//   '#7B90B6',
//   '#56637B',
//   '#FFBE29',
//   '#FF943B',
//   '#78A4FF',
//   '#8C84FF',
//   '#C0BCFF',
//   '#FFC092'
// ]

const colorArr = [
  '#ee6666',
  '#fac858',
  '#3ba272',
  '#5470c6',
  '#91cc75',
  '#ee6666',
  '#73c0de',
  '#fc8452',
  '#ea7ccc',
]

module.exports = { colorArr }
